module.exports = __webpack_public_path__ + "img/pv-search.48244adb.svg";